<form class="form-popup" [formGroup]="formGroup">
  <div class="modal-body">
    <div class="row top10 vcenter">
      <div class="col-xs-4 text-right">
        <b>Select Employee(s):</b>
      </div>

      <div class="col-xs-8">

      <div><p>Any Employee selected, but already assigned Individual Training will be ignored.</p></div>

      <mat-form-field appearance="fill">
            <mat-select multiple
              name="empls"
              formControlName="employeeIds"
              >
              <mat-option *ngFor="let e of employeePuValues | async" [value]="e.employeeId"> {{ e.fullName }}</mat-option>
            </mat-select>
          </mat-form-field>
      </div>
    </div>
  </div>
</form>
